import {
  Dialog,
  DialogBackdrop,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { CancelIcon } from "../../../assets/icons";
import Constant from "../../../utils/constant";
import LinkedStandardDetail from "../../shared/common/linkedStandardDetail";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";

const DelinkStandardPopup: React.FC<any> = ({
  standardId,
  title,
  buttonText,
  confirmAction,
  linkedStandardsData,
  onClose,
  disableAction = false,
}: {
  standardId;
  title: string;
  buttonText: string;
  confirmAction: (isConfirm: boolean, standardId: number) => void;
  linkedStandardsData: IlinkedStandard[];
  onClose?: () => void;
  disableAction: boolean;
}) => {
  const [linkedStandards, setLinkedStandards] = useState<any>([]);
  function bindLinkedStandard() {
    setLinkedStandards(linkedStandardsData);
  }

  useEffect(() => {
    bindLinkedStandard();
  }, []);
  return (
    <div>
      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0"
          onClose={() => {
            if (disableAction && onClose) onClose();
            else confirmAction(false, standardId);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity " />
            </TransitionChild>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white text-left  shadow-xl transform transition-all sm:align-middle w-2/3 h-auto  rounded-lg overflow-hidden">
                <div>
                  <header className="sticky">
                    <div className="px-4 py-4 bg-gray-50 sm:px-4">
                      <div className="flex items-start justify-between space-x-3">
                        <div className="space-y-1">
                          <div className="text-lg font-medium text-gray-900">
                            {title}
                          </div>
                        </div>
                        <div className="h-7 flex items-center">
                          <button
                            type="button"
                            className="text-gray-400 hover:text-gray-500"
                          >
                            <span className="sr-only">Close panel</span>
                            <CancelIcon
                              onClick={() => {
                                if (disableAction && onClose) onClose();
                                else confirmAction(false, standardId);
                              }}
                            ></CancelIcon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </header>
                  <div className="relative overflow-y-auto ">
                    <div className="w-full p-3 h-27 md:h-27 2xl:h-27">
                      {linkedStandards &&
                        linkedStandards.some(
                          (r) =>
                            r.linkingType ===
                            Constant.StandardLinkingType.ONEWAY
                        ) && (
                          <div>
                            <div className="flex items-end justify-between mb-3">
                              <h3 className="text-primary-color font-medium text-sm tracking-wide">
                                One Way Link
                              </h3>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                              {linkedStandards
                                .filter(
                                  (r) =>
                                    r.linkingType ===
                                    Constant.StandardLinkingType.ONEWAY
                                )
                                .map((linkedStandard, index) => {
                                  linkedStandard.sourceStandardId = standardId;
                                  const linkedStandardProps = {
                                    ...linkedStandard,
                                    bindStandards: bindLinkedStandard,
                                  };
                                  return (
                                    <Fragment key={index}>
                                      <LinkedStandardDetail
                                        {...linkedStandardProps}
                                      />
                                    </Fragment>
                                  );
                                })}
                            </div>
                          </div>
                        )}

                      {linkedStandards &&
                        linkedStandards.some(
                          (r) =>
                            r.linkingType ===
                            Constant.StandardLinkingType.TWOWAY
                        ) && (
                          <div>
                            <h3 className="text-primary-color mb-3 mt-4 font-medium text-sm tracking-wide">
                              Two Way Link
                            </h3>
                            <div className="grid grid-cols-2 gap-x-4 gap-y-4">
                              {linkedStandards
                                .filter(
                                  (r) =>
                                    r.linkingType ===
                                    Constant.StandardLinkingType.TWOWAY
                                )
                                .map((linkedStandard, index) => {
                                  linkedStandard.sourceStandardId = standardId;
                                  const linkedStandardProps = {
                                    ...linkedStandard,
                                    bindStandards: bindLinkedStandard,
                                  };
                                  return (
                                    <Fragment key={index}>
                                      <LinkedStandardDetail
                                        {...linkedStandardProps}
                                      />
                                    </Fragment>
                                  );
                                })}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                  <footer className="flex flex-col items-center justify-end px-6 py-4 sm:flex-row bg-gray-50 dark:bg-gray-800">
                    <div className="flex-shrink-0">
                      <div className="space-x-3 flex justify-end">
                        {!disableAction && (
                          <>
                            <button
                              onClick={() => confirmAction(true, standardId)}
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                            >
                              {buttonText}
                            </button>
                            <button
                              onClick={() => confirmAction(false, standardId)}
                              type="button"
                              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                        {disableAction && (
                          <button
                            onClick={() => {
                              if (onClose) onClose();
                            }}
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                          >
                            {buttonText}
                          </button>
                        )}
                      </div>
                    </div>
                  </footer>
                </div>
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default DelinkStandardPopup;
